export default __webpack_public_path__ + "static/media/regression_bottom.569fc6e1.png";